"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PopoverContext: function() {
        return PopoverContext;
    },
    PopoverProvider: function() {
        return PopoverProvider;
    },
    usePopoverContext_unstable: function() {
        return usePopoverContext_unstable;
    }
});
const _reactcontextselector = require("@fluentui/react-context-selector");
const PopoverContext = (0, _reactcontextselector.createContext)(undefined);
const popoverContextDefaultValue = {
    open: false,
    setOpen: ()=>null,
    toggleOpen: ()=>null,
    triggerRef: {
        current: null
    },
    contentRef: {
        current: null
    },
    arrowRef: {
        current: null
    },
    openOnContext: false,
    openOnHover: false,
    size: 'medium',
    trapFocus: false,
    inline: false
};
const PopoverProvider = PopoverContext.Provider;
const usePopoverContext_unstable = (selector)=>(0, _reactcontextselector.useContextSelector)(PopoverContext, (ctx = popoverContextDefaultValue)=>selector(ctx));
